import {isMobile} from "../helpers";

export default () => ({

    video: null,
    /**
         * Init player
         */
    init() {
        if(!isMobile())return;
        this.$root.style.maxHeight = `${window.innerHeight*0.7}px`
    },
});
